module.exports = __webpack_public_path__ + "static/media/pageBreak.fd45a344.svg";